import { Component, Input } from '@angular/core';
import { dongleState, grooveState } from 'src/app/app.animation';
import { EmployeeManagementService } from '../../../employee-management/employee-management.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { customJwtDecode as decode } from 'src/app/shared/helpers/custom-jwt';
import { EncrypterService } from 'src/app/shared/services/encrypter.service';
import { ToastrService } from 'ngx-toastr';
import { EmployeeLoginService } from '../../../employee-login/employee-login.service';
import { ChangeDetectorRef } from '@angular/core';
import { ApprovalsService } from '../../../approvals/approvals.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as global_constant from 'src/app/shared/global-constants';
import { DomSanitizer } from '@angular/platform-browser';
import { BroadcasterService } from '../../../broadcaster/broadcaster.service';
import * as moment from 'moment';
import { ReportService } from '../../../reports/report.service';
import { EmployeeDashboardService } from '../../services/employee-dashboard.service';
// import * as fs from 'file-saver';
declare var $: any;


// --- ADDED: Interfaces for the clearance form data ---
interface ClearanceItem {
  remarks: string;
  deducation_amount: number;
  id: number;
  asset_item: string;
  is_cleared: string;
  department_name: string;
  originalIndex?: number;
}
interface EmployeeDetailsForForm {
  emp_name: string;
  orgempcode: string;
  posting_department: string;
  current_designation: string;
  dateofjoining: string;
  dateofresignation: string;
  hodRo: string;
  last_working_day_at_the_organization: string;
}

interface FullFinalEmployee {
  clearance_approved_status: string;
  is_feedback_link_status: boolean;
  emp_code: number;
  emp_name: string;
  orgempcode?: string;
  tpcode?: string;
  exit_status: string;
  post_offered: string;
  posting_department: string;
}
@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.css'],
  animations: [dongleState, grooveState],
  standalone: false,
})
export class ApprovalsComponent {


  @Input() empDataFromParent: any;
  showAddApprovalModal: boolean = false;
  token: any;
  tp_account_id: any;
  payout_method: any;
  product_type: string;
  approvalList: any = [];
  approvalDataByActionType: any = [];
  activeEmp: any = '';
  remarks: string = '';
  expense_amount: string = '';
  addRemarks: boolean = false;
  activeLeaveType: any = '';
  leaveStatus: any = 'P';
  isShowEmpDetails: boolean = false;
  isShowEmployeeDetails: boolean = false;
  empDetails: any = '';
  fromDate: any = '';
  toDate: any = '';
  approvalType: any = '';
  approvedAmount: any = '0';
  modalHeadText: any = '';
  isTicketFile: boolean = false;
  isHotelBill: boolean = false;
  compoff_leaves: any;
  compoff_leaves_flag: string;
  expenseAmountError: boolean = false;

  employeesInFullFinal: FullFinalEmployee[] = [];
  ouIds: any;
  fullAndFinal: boolean = false;

  // --- ADDED: Properties to manage the Exit Clearance Form directly in this component ---
  showExitClearanceModal: boolean = false;
  clearanceForm!: FormGroup;
  isLoadingAccess = true;
  canAccessForm = false;
  is_submitted = false;
  clearanceFormEmployeeDetails: EmployeeDetailsForForm;
  allClearanceItems: ClearanceItem[] = [];
  groupedItems: { [key: string]: ClearanceItem[] } = {};
  departmentKeys: string[] = [];
  showEmployeeInfo = true;
  showTable = true;
  showSignature = true;
  name: string;
  mobile: string;
  is_clearance_approved: boolean;
  is_clearance_approved_by_employer: boolean;
  exit_count: number = 0;
  searchText: string = '';
  logofileErrorPdf: string;
  logofileError: string;
  logofileName: any;
  logoPreviewUrl: string | ArrayBuffer;
  logobase64Data: string;
  private _allApprovalDataByActionType: any[] = []; // Backup for original list
  private _allEmployeesInFullFinal: FullFinalEmployee[] = [];
  isMoreThanTwoDays: boolean;
  azureImagePath: any;
  accountsWFHAllowed = global_constant?.GlobalConstants?.wfh_allowed_for_more_than_two || [];
  pdfModal: boolean = false;
  pdfUrlViewIdCard: any;
  leaveDetailsForApproval: any;

  constructor(
    private _employeeMgmtService: EmployeeManagementService,
    private _sessionService: SessionService,
    private _encrypterService: EncrypterService,
    private _ReportService: ReportService,
    private toastr: ToastrService,
    private _employeeLoginService: EmployeeLoginService,
    private broadcasterService: BroadcasterService,
    private cdr: ChangeDetectorRef,
    private _approvalsService: ApprovalsService,
    private sanitizer: DomSanitizer,
    private dashboardService: EmployeeDashboardService,
    // --- ADDED: FormBuilder for the clearance form ---
    private fb: FormBuilder) { }

    // --- ADDED: Bulk Approval Properties ---
    selectAll: boolean = false;
    showBulkApproveModal: boolean = false;
    bulkRemarks: string = '';
    bulkActionType: string = 'A'; // 'A' for Approve, 'R' for Reject
    
    get selectedCount(): number {
      return this.approvalDataByActionType.filter((item: any) => item.isSelected).length;
    }

    toggleSelectAll() {
      // Only select items that are actionable (show action buttons)
      const actionableItems = this.approvalDataByActionType.filter((item: any) => this.isShowActionButton(item));
      
      const allSelected = actionableItems.every((item: any) => item.isSelected);
      
      this.approvalDataByActionType.forEach((item: any) => {
        if (this.isShowActionButton(item)) {
          item.isSelected = !allSelected;
        }
      });
      this.selectAll = !allSelected;
    }

    updateSelection() {
       const actionableItems = this.approvalDataByActionType.filter((item: any) => this.isShowActionButton(item));
       if(actionableItems.length > 0){
          this.selectAll = actionableItems.every((item: any) => item.isSelected);
       }else{
         this.selectAll = false;
       }
    }

    openBulkApproveModal(action: string) {
      if (this.selectedCount === 0) return;
      this.bulkActionType = action;
      this.showBulkApproveModal = true;
      this.bulkRemarks = '';
    }

    closeBulkApproveModal() {
      this.showBulkApproveModal = false;
      this.bulkRemarks = '';
    }

    bulkApproveAction() {
       const selectedItems = this.approvalDataByActionType.filter((item: any) => item.isSelected);
       if (selectedItems.length === 0) return;

       this.processBulkItems(selectedItems, this.bulkActionType);
    }

    processBulkItems(items: any[], action: string) {
      let processedCount = 0;
      const total = items.length;

      items.forEach((item) => {
        let subscription;
        
        // Common postData properties
        let postData: any = {
           customerAccountId: this.tp_account_id.toString(),
           empId: item?.emp_id,
           empCode: item?.emp_code,
           productTypeId: this.product_type,
           submittedBy: this.empDataFromParent.emp_code,
           createdByIp: "::1",
           approvalStatus: action,
           remark: this.bulkRemarks
        };

        if (this.approvalType == 'Leave') {
           postData.approvalId = item?.leave_applid;
           subscription = this._employeeMgmtService.approveRejectLeave(postData);

        } else if (this.approvalType == 'On Duty') {
           postData.approvalId = item?.od_applid;
           subscription = this._employeeLoginService.approveRejectOnDuty(postData);

        } else if (this.approvalType == 'Comp-Off Request') {
           postData.approvalId = item?.comp_applid;
           // For bulk, we assume the requested comp-off days are approved as is.
           postData.comp_off_days = item?.comp_off_days?.toString();
           subscription = this._employeeLoginService.approveRejectCompOffRequest(postData);

        } else if (this.approvalType == 'WFH Request') {
           postData.approvalId = item?.wfh_applid;
           postData.p_attachment_url = ''; // Assuming no attachment for bulk
           subscription = this._employeeLoginService.approveRejectWFHRequest(postData);
           // Note: Push notification logic skipped for bulk to avoid spam/complexity, or could be added.

        } else if (this.approvalType == 'Imprest Request') {
           // Imprest payload is different
           let obj = {
            customeraccountid: this.tp_account_id.toString(),
            action: "approved_ir_mobile_app",
            emp_id: item?.emp_id,
            approval_status: action,
            subuser_id: this.token?.subuser_id?.toString(),
            isemployer: this.token?.isEmployer?.toString(),
            user_name: item.emp_name,
            submittedby: this.empDataFromParent.emp_code,
            remark: this.bulkRemarks,
            amount_spent: item?.amount_spent, // Approving the requested amount
            appliedid: item?.ir_applid,
          }
          
          subscription = this._employeeLoginService.approveRejectImprestRequest(obj); 
           // Note: Voucher creation for 'A' is also needed if successful. handling in subscribe.

        } else if (this.approvalType == 'Travel Request') {
		postData.approvalId = item?.leave_applid; // Check if this is correct ID. requestAction uses generic logic. 
																											 
																			  
																							 
													
														
											  
																						
																				 
																		  
             postData.travelId = item?.travel_id;
             postData.travelStatus = action;
             postData.approvalId = item?.leave_applid; // Assuming fallback 
             postData.travelRemarks = this.bulkRemarks;

             subscription = this._employeeLoginService.approveTravelRequest(postData);

        } else if (this.approvalType == 'Travel Expense') {
             postData.approvalId = item?.leave_applid;
             postData.travelId = item?.travel_id;
             postData.travelStatus = action;
             postData.approvedAmount = item?.approved_amount_spent || item?.amount_spent || 0;
             postData.travelRemarks = this.bulkRemarks;

             subscription = this._employeeLoginService.approveRejectTravelExpense(postData);

        } else if (this.approvalType == 'Missed Punch') {
             // Missed Punch payload is completely different
             let obj = {
                action: "ApproveMissedPunch",
                approvalId: item?.row_id,
                customerAccountId: this._encrypterService.aesEncrypt(this.tp_account_id.toString()),
                empCode: this._encrypterService.aesEncrypt(item?.emp_code),
                attDate: item?.att_date ? item.att_date.replace(/\//g, '-') : '',
                attStatus: action,
                "modifiedByUser": this.empDataFromParent?.emp_code,
                "modifiedByIp": "::2",
                "productTypeId": this._encrypterService.aesEncrypt(this.product_type),
                "isEmployer": this.token?.isEmployer,
                "subUserId": "0",
                remarks: this.bulkRemarks
              }
              subscription = this._employeeLoginService.approveRejectMissedPunch(obj);
        } else if (this.approvalType == 'Reimbursement Claim') {
           const isWorkflow = item?.is_workflow_applied === 'Y';
           const approverEmpCode = this.empDataFromParent?.emp_code || this.token?.emp_code || '';
           const approverName = this.empDataFromParent?.emp_name || this.token?.name || '';
           let claimPayload = {
             actionType: action == 'A' ? (isWorkflow ? 'ApproveClaimLevel' : 'updateClaimStatus') : 'updateClaimStatus',
             claimStatus: action,
             claimRejectReason: this.bulkRemarks || (action == 'A' ? 'Approved' : 'Rejected'),
             approvedAmount: item?.approved_amount || item?.expense_amount,
             empCode: item.emp_code,
             claimRecordId: item.claim_record_id,
             productTypeId: this.product_type,
             customerAccountId: this.tp_account_id?.toString(),
             createdBy: approverEmpCode,
             modifiedBy: approverEmpCode,
             subUserId: '',
             isEmployer: '0',
             actionByRole: 'Approver',
             approverName: approverName
           };
           subscription = this._employeeMgmtService.ManageReimbursementClaim(claimPayload);
        }

        if (subscription) {
            subscription.subscribe((resData: any) => {
                processedCount++;
                
                // Specific success logic (like Voucher for Imprest)
                if (this.approvalType == 'Imprest Request' && resData.statusCode && resData.checkflag == 'A' && action == 'A') {
                     // Construct Voucher Obj
                      let date = new Date();
                      let month = date.getMonth() + 1;
                      let year = date.getFullYear();
                      let createdby = this.token.isEmployer == '0' ? (!this.token?.sub_userid ? this.tp_account_id : this.token.sub_userid) : this.tp_account_id;
                      
                      let voucher_obj = {
                        "voucherYear": year,
                        "voucherMonth": month,
                        "empCode": item?.mobile + 'CJHUB' + item?.emp_code + 'CJHUB' + item?.dateofbirth,
                        "amount": item?.amount_spent?.toString(),
                        "transactionType": "Credit",
                        "ledgerType": "Reimbursement",
                        "deductionId": item?.expense_category_id?.toString(),
                        "subLedgerName": item?.expense_category_name,
                        "isTaxableFlag": "N",
                        "IsBillableFlag": "N",
                        "createdBy": createdby?.toString(),
                        "productTypeId": this.product_type.toString(),
                        "customerAccountId": this.tp_account_id.toString(),
                      }
                  //    this.saveVoucher(voucher_obj); // check if saveVoucher exists
                }

                if (processedCount === total) {
                    this.toastr.success(`Bulk processing completed`);
                    this.closeBulkApproveModal();
                    this.openAddApprovalModal(this.activeLeaveType);
                    this.getMasterList();
                }
            }, (error: any) => {
                 processedCount++;
                 if (processedCount === total) { // Even if last one errors, refresh
                    this.closeBulkApproveModal();
                    this.openAddApprovalModal(this.activeLeaveType);
                    this.getMasterList();
                 }
            });
        } else {
             processedCount++; // Skip if unknown type
             if (processedCount === total) {
                this.closeBulkApproveModal();
                this.getMasterList();
             }
        }
      });
    }

  ngOnInit() {
    let session_obj_d: any = JSON.parse(
      this._sessionService.get_user_session());
    this.token = decode(session_obj_d.token);
    this.empDataFromParent = this.empDataFromParent || JSON.parse(localStorage.getItem('empDataFromParent') || 'null');
    if (!this.empDataFromParent) {
      this.empDataFromParent = {
        emp_code: this.token?.emp_code || this.token?.id || '',
        emp_name: this.token?.name || '',
        mobile: this.token?.mobile || ''
      };
    }

    this.name = this.token.name;
    this.mobile = this.token.mobile;
    this.tp_account_id = this.token.tp_account_id;
    this.payout_method = this.token.payout_mode_type;
    this.product_type = localStorage.getItem('product_type') || this.token.product_type;
    this.ouIds = this.token.ouIds;

    // this.getMasterList()
  }

  ngAfterViewInit() {

    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);

    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    setTimeout(() => {
      $('#FromDate').datepicker({
        dateFormat: 'dd-mm-yy',
        changeMonth: true,
        changeYear: true,
      }).datepicker('setDate', startDate);

      $('#ToDate').datepicker({
        dateFormat: 'dd-mm-yy',
        changeMonth: true,
        changeYear: true,
      }).datepicker('setDate', tomorrow);

      $('body').on('change', '#FromDate', function () {
        $('#recdate').trigger('click');
      });

      $('body').on('change', '#ToDate', function () {
        $('#recdate').trigger('click');
      });

    }, 100);
    // .datepicker('setDate', new Date());
    this.getMasterList();

  }

  getMasterList() {

    this._employeeMgmtService.getMasterListingOfApproval({
      customerAccountId: (this.tp_account_id || '').toString(),
      empCode: this.empDataFromParent?.emp_code || this.token?.emp_code || this.token?.id || '',
      productTypeId: this.product_type,
      approvalId: '',
      // fromDt: this.fromDate.split('-').reverse().join('-'),
      // toDt : this.toDate.split('-').reverse().join('-'),
      fromDt: this.fromDate || "",
      toDt: this.toDate || "",
      statusFilter: this.leaveStatus
    }).subscribe((resData: any) => {
      if (resData.statusCode) {
        this.approvalList = JSON.parse(this._encrypterService.aesDecrypt(resData.commonData));
        // 🔥 UPDATE DASHBOARD COUNTS
        this.pushDashboardCounts(this.approvalList);
        // this.approvalList = this.approvalList.filter((item)=> item.approvalactiontype != "get_imprest_req_app");
        // console.log("approvalList", this.approvalList)
      } else {
        this.approvalList = [];
      }
    })
  }
  private pushDashboardCounts(list: any[]) {
    let pendingApprovals = 0;
    let leaveRequests = 0;
    let otherRequests = 0;
    let attendance = 0;
    list.forEach(item => {
      pendingApprovals += Number(item.approvalcount || 0);
      if (item.approvaltype === 'Leave') {
        leaveRequests += Number(item.approvalcount || 0);
      } else if (item.approvaltype === 'Missed Punch') {
        attendance += Number(item.approvalcount || 0);
      } else {
        otherRequests += Number(item.approvalcount || 0);
      }
    });
    this.dashboardService.updateCounts({
      pendingApprovals,
      leaveRequests,
      attendance,
      otherRequests,
      leaveStatus: this.leaveStatus,
    });
  }

  getDateWiseData() {
    this.fromDate = $('#FromDate').val();
    this.toDate = $('#ToDate').val();

    if (this.fromDate && this.toDate) {
      this.getMasterList();
    }
  }

  getLeaveByStatus(status: any) {
    this.leaveStatus = status;
    this.getMasterList();
    // this.getExitProcessData();
  }

  openAddApprovalModal(approval: any) {
    if (approval.approvalcount == 0) {
      return;
    }

    this.showAddApprovalModal = true;
    this.activeLeaveType = approval;

    this.approvalType = approval.approvaltype;

    let body = document.querySelector('body');
    if (body) {
      body.classList.add('modal-open');
    }

    let obj = {
      customerAccountId: (this.tp_account_id || '').toString(),
      empCode: this.empDataFromParent?.emp_code || this.token?.emp_code || this.token?.id || '',
      productTypeId: this.product_type,
      approvalId: '',
      fromDt: this.fromDate || "",
      toDt: this.toDate || "",
      statusFilter: this.leaveStatus,
      actionType: approval.approvalactiontype
    }
    // console.log("OBJ FOR API --", obj)

    this._employeeMgmtService.getApprovalRequestByActionType(obj).subscribe((resData: any) => {
      if (resData.statusCode) {
        const data = JSON.parse(this._encrypterService.aesDecrypt(resData.commonData));
        this.approvalDataByActionType = data;
        // --- ADDED: Store the original list in the backup property ---
        this._allApprovalDataByActionType = data;
        console.log("DATA FROM API --", this.approvalDataByActionType)
        // this.Get_employee_leave_balance(this.approvalDataByActionType);
      } else {
        this.approvalDataByActionType = [];
        this._allApprovalDataByActionType = [];
      }
    })
  }

  // Get_employee_leave_balance(approvalDataArray: any) {

  //   for (let data of approvalDataArray) {
  //     let obj = {
  //       "empid": data?.emp_id,
  //       'accountId': this.tp_account_id?.toString(),
  //       'p_geofenceid': '',
  //       'ouIds': ''
  //     };

  //     this._ReportService.get_employee_leave_balance_el(obj).subscribe({
  //       next: (resData: any) => {
  //         if (resData.statusCode) {
  //          let balanceData = resData.commonData[0];

  //         // ---- GET balance list ----
  //         const balanceList = balanceData?.balance_txt || [];

  //         // ---- Find matching balance for this leave ----
  //         const match = balanceList.find((x: any) =>
  //           x.type_code === data.leavetypecode
  //         );

  //         // ---- Attach balance data inside your leave row ----
  //         data.leave_balance = match ? {
  //           current_balance: match.cur_bal,
  //           initial_balance: match.init_bal,
  //           leave_taken: match.leave_taken,
  //           future_days: match.future_days,
  //           type_name: match.type_name
  //         } : null;

  //         // console.log("DATA FROM API --", this.approvalDataByActionType)
  //         } else {
  //           this.toastr.error(resData.message, 'Oops!');
  //         }
  //       }, error: (e) => {
  //       }
  //     })
  //   }
  // }



  //added for exit process
  openAddApprovalModalForExit(approval: any) {

    this.fullAndFinal = true;
    this.showAddApprovalModal = true;
    this.activeLeaveType = approval;
    this.approvalType = "Exit Employee List";

    let body = document.querySelector('body');
    if (body) {
      body.classList.add('modal-open');
    }

    // Call Full and Final Employee Data API

    // this.getExitProcessData();
  }

  getExitProcessData() {
    const payload = {
      customerAccountId: this.tp_account_id,
      empCode: this.empDataFromParent.emp_code,  // use same empCode as above
      ouIds: "",
      postOffered: "",
      postingDepartment: "",
      unitParameterName: "",
      status: "FNFPending",
      actionType: "GetExitEmployeeByReportingMgr"
    };
    // console.log("payload", payload);
    this._employeeMgmtService.getFullAndFinalDetail(payload).subscribe({
      next: (res: any) => {
        // console.log(res);
        if (res?.statusCode === true && res?.commonData) {
          // console.log(res);
          try {
            const decryptedData = JSON.parse(this._encrypterService.aesDecrypt(res.commonData));
            // console.log("decrepted data", decryptedData);
            let employees = Array.isArray(decryptedData) ? decryptedData : [];
            // console.log("status", this.leaveStatus);
            if (this.leaveStatus == 'A') {
              employees = this.employeesInFullFinal.filter(employee => {
                return employee.clearance_approved_status === 'Approved';
              });

            } else {
              if (this.leaveStatus == 'R') {
                employees = this.employeesInFullFinal.filter(employee => {
                  return employee.clearance_approved_status === 'Rejected';
                });
              }
              else {
                employees = this.employeesInFullFinal.filter(employee => {
                  return employee.clearance_approved_status !== 'Approved' &&
                    employee.clearance_approved_status !== 'Rejected';
                });
              }
            }
            this.employeesInFullFinal = employees;
            this._allEmployeesInFullFinal = employees;
            this.exit_count = this.employeesInFullFinal.length;
            // console.log("Employee Full & Final Data:", this.employeesInFullFinal);
          } catch (error) {
            // console.error('Error parsing Full & Final decrypted data:', error);
            this.employeesInFullFinal = [];
            this._allEmployeesInFullFinal = [];
          }
        }

      },
      error: (err: any) => {
        // console.error('Error fetching Full and Final employees:', err);
        this.employeesInFullFinal = [];

      }
    });
  }
  //end

  closeAddApprovalModal() {
    this.selectAll = false; // Reset select all
    this.fullAndFinal = false;
    this.showAddApprovalModal = false;
    this.activeLeaveType = '';
    this.approvalDataByActionType = []
    this._allApprovalDataByActionType = []; // Clear backup
    // --- ADDED: Reset search text on modal close ---
    this.searchText = '';
    let body = document.querySelector('body');
    if (body) {
      body.classList.remove('modal-open');
    }
  }

  isShowActionButton(empData: any): boolean {
    let isActionTypeVisible = false;

    if (this.leaveStatus == 'P') {

      if ((empData.is_workflow_applied == 'N') || (empData.is_workflow_applied_req == 'N') || (empData.is_workflow_applied_exp == 'N')) {
        isActionTypeVisible = true;
      } else {
        if (empData.template_mode == 'strict') {
          if (empData.wf_approval_cur_level == empData.user_approval_level
            || (empData.wf_approval_cur_level_req == empData.user_approval_level)
            || (empData.wf_approval_cur_level_exp == empData.user_approval_level)
          ) {
            isActionTypeVisible = true;
          }
        } else {
          if (empData.max_reporting_level == empData.user_approval_level) {
            isActionTypeVisible = true;
          } else {
            if ((empData.wf_approval_cur_level <= empData.max_reporting_level)
              || (empData.wf_approval_cur_level_req <= empData.max_reporting_level)
              || (empData.wf_approval_cur_level_exp <= empData.max_reporting_level)
            ) {
              isActionTypeVisible = true;
            }
          }
        }
      }

    }
    return isActionTypeVisible;
  }

  canSendBack(employee: any): boolean {
    if (this.approvalType !== 'Reimbursement Claim') return false;
    return employee?.is_workflow_applied === 'Y' && 
           (employee?.approval_status === 'Pending' || employee?.expense_doc_status_code === 'P') && 
           Number(employee?.wf_approval_cur_level) > 1 &&
           this.isShowActionButton(employee);
  }

  canPullBack(employee: any): boolean {
    if (this.approvalType !== 'Reimbursement Claim') return false;
    return employee?.is_workflow_applied === 'Y' && 
           (employee?.approval_status === 'Pending' || employee?.expense_doc_status_code === 'P') && 
           Number(employee?.wf_approval_cur_level) > 1 &&
           (!employee?.user_approval_level || Number(employee?.user_approval_level) === Number(employee?.wf_approval_cur_level) - 1);
  }

  openExitClearanceModal(employee: any) {
    this.activeEmp = employee;
    this.showExitClearanceModal = true;
    // Trigger the data loading for the form
    this.initializeEmptyForm();
    this.loadDataAndBuildForm();
  }
  initializeEmptyForm(): void {
    this.clearanceForm = this.fb.group({
      employeeName: [{ value: '', disabled: true }],
      employeeCode: [{ value: '', disabled: true }],
      designation: [{ value: '', disabled: true }],
      department: [{ value: '', disabled: true }],
      dateOfJoining: [{ value: '', disabled: true }],
      hodRo: [{ value: '', disabled: true }],
      dateOfResignation: [{ value: '', disabled: true }],
      lastWorkingDay: [{ value: '', disabled: true }],
      clearanceItems: this.fb.array([]),
      // approvalRemark: ['']
    });
  }

  closeExitClearanceModal() {
    this.showExitClearanceModal = false;
    this.activeEmp = null;
    // Reset form state to ensure it's fresh next time
    this.clearanceForm = null;
    this.isLoadingAccess = true;
    this.canAccessForm = false;
  }

  // --- ADDED: All methods required to manage the clearance form ---

  get clearanceItemsArray(): FormArray {
    return this.clearanceForm.get('clearanceItems') as FormArray;
  }

  loadDataAndBuildForm(): void {
    if (!this.activeEmp?.emp_code) {
      this.toastr.error("Employee data not provided. Cannot load form.");
      this.isLoadingAccess = false;
      this.canAccessForm = false;
      return;
    }

    this.isLoadingAccess = true;
    const payload = {
      customerAccountId: this.tp_account_id,
      empCode: this.activeEmp.emp_code, // Use the emp_code from the selected employee
      productTypeId: this.product_type,
      actionType: 'Get_MST_CLEARANCE_FORM',
    };

    // Use the service that gets the form details
    this._employeeLoginService.getExitFormDetails(payload).subscribe({
      next: (res: any) => {
        if (res?.statusCode === true && res?.commonData) {
          const data = JSON.parse(this._encrypterService.aesDecrypt(res.commonData));
          this.canAccessForm = true;
          // console.log(data);
          this.clearanceFormEmployeeDetails = data[0]?.employeedetails?.[0] || {};
          this.allClearanceItems = data[0]?.exit_master_reason || [];
          this.is_submitted = data[0]?.submit_status || false;
          this.is_clearance_approved = data[0]?.basic_details?.final_approval_status == "Approved" || false;
          this.is_clearance_approved_by_employer = data[0]?.basic_details?.current_approval_role == "employer" || false;
          this.groupItemsByDepartment(this.allClearanceItems);
          this.populateClearanceForm(this.clearanceFormEmployeeDetails, this.allClearanceItems);

          if (this.is_clearance_approved) {
            this.clearanceForm.disable();
          }
        } else {
          this.toastr.error(res?.message || "Could not load clearance form data.");
          this.canAccessForm = false;
        }
        this.isLoadingAccess = false;
      },
      error: (err) => {
        // console.error('Error loading clearance data:', err);
        this.toastr.error("An error occurred while fetching form data.");
        this.canAccessForm = false;
        this.isLoadingAccess = false;
      },
    });
  }

  populateClearanceForm(details: EmployeeDetailsForForm, items: ClearanceItem[]): void {
    this.clearanceForm.patchValue({
      employeeName: details.emp_name,
      employeeCode: details.orgempcode,
      designation: details.current_designation,
      department: details.posting_department,
      dateOfJoining: details.dateofjoining,
      hodRo: details.hodRo,
      dateOfResignation: details.dateofresignation,
      lastWorkingDay: details.last_working_day_at_the_organization,
      employeeDate: new Date().toISOString().split('T')[0]
    });

    this.clearanceItemsArray.clear();
    items.forEach(item => {
      this.clearanceItemsArray.push(this.fb.group({
        id: [item.id],
        asset_item: [{ value: item.asset_item, disabled: true }],
        status: [item.is_cleared, Validators.required],
        remarks: [item.remarks || ''],
        deducation_amount: [{ value: item.deducation_amount || 0, disabled: true }],
      }));
    });
  }


  // createClearanceItemControls(): FormGroup[] {
  //   return this.allClearanceItems.map(item => this.fb.group({
  //     id: [item.id],
  //     status: [item.is_cleared || '', Validators.required],
  //   }));
  // }


  groupItemsByDepartment(items: ClearanceItem[]): void {
    this.groupedItems = items.reduce((acc, item, index) => {
      const dept = item.department_name;
      if (!acc[dept]) {
        acc[dept] = [];
      }
      acc[dept].push({ ...item, originalIndex: index });
      return acc;
    }, {} as { [key: string]: ClearanceItem[] });

    this.departmentKeys = Object.keys(this.groupedItems);
  }

  submitClearanceForm() {
    if (this.clearanceForm.invalid) {
      this.toastr.error('Please fill all required fields before submitting.');
      this.clearanceForm.markAllAsTouched();
      return;
    }

    const formData = this.clearanceForm.getRawValue();
    const send_payload = {
      empCode: this.activeEmp.emp_code,
      customerAccountId: this.tp_account_id,
      createdBy: this.empDataFromParent.emp_code, // Approver's code
      createdIp: "::1",
      clearanceData: JSON.stringify(formData.clearanceItems.map(item => ({
        clearance_master_id: item.id,
        is_cleared: item.status,
        remarks: item.remarks || "",
        deducation_amount: item.deducation_amount || 0,
        verified_by: this.empDataFromParent.emp_code // Approver is verifying
      }))),
      actionType: "reporting_manager" // Specify the action is by an approver
    };

    // Use the service that saves the form data
    this._employeeLoginService.saveCleranceForm(send_payload).subscribe({
      next: (res: any) => {
        if (res?.statusCode === true || res?.status === 'success') {
          this.toastr.success(res?.message || 'Clearance form submitted successfully!');
          this.closeExitClearanceModal();
          // Refresh the list of employees
          this.openAddApprovalModalForExit(this.activeLeaveType);
          this.getExitProcessData();

        } else {
          this.toastr.error(res.message || 'Submission failed. Please try again.');
        }
      },
      error: (err) => {

        this.toastr.error(err.message || 'An error occurred during submission.');
      }
    });
  }

  approveClearanceForm() {
    if (this.clearanceForm.invalid) {
      this.toastr.error('Please fill all required fields before submitting.');
      this.clearanceForm.markAllAsTouched();
      return;
    }

    const formData = this.clearanceForm.getRawValue();
    const send_payload = {
      empCode: this.activeEmp.emp_code,
      customerAccountId: this.tp_account_id,
      createdBy: this.empDataFromParent.emp_code, // Approver's code
      createdIp: "::1",
      clearanceData: JSON.stringify(formData.clearanceItems.map(item => ({
        clearance_master_id: item.id,
        is_cleared: item.status,
        remarks: item.remarks || "",
        deducation_amount: item.deducation_amount || 0,
        verified_by: this.empDataFromParent.emp_code // Approver is verifying
      }))),
      approve_details: JSON.stringify([{
        approvalStatus: "Approved",
        approvalBy: this.token.id,
        approvalRemark: "",
        approvalUserType: "Reporting Manager",
        approvalUser: this.name + "#" + this.mobile,
      }]),
      actionType: "reporting_manager" // Specify the action is by an approver
    };

    // Use the service that saves the form data
    this._employeeLoginService.saveCleranceForm(send_payload).subscribe({
      next: (res: any) => {
        if (res?.statusCode === true || res?.status === 'success') {
          this.toastr.success(res?.message || 'Clearance form submitted successfully!');
          this.closeExitClearanceModal();
          // Refresh the list of employees
          this.openAddApprovalModalForExit(this.activeLeaveType);
          this.getExitProcessData();
        } else {
          this.toastr.error(res.message || 'Submission failed. Please try again.');
        }
      },
      error: (err) => {

        this.toastr.error(err.message || 'An error occurred during submission.');
      }
    });
  }

  // --- ADDED: UI Toggle Functions for the form sections ---
  toggleEmployeeInfo() { this.showEmployeeInfo = !this.showEmployeeInfo; }
  toggleTable() { this.showTable = !this.showTable; }

  // --- All your other existing methods remain below ---


  hideEmpDetailModal() {
    this.isShowEmpDetails = false;
    this.isShowEmployeeDetails = false;
    this.addRemarks = false;
    this.approvedAmount = 0;
    this.remarks = '';
    this.compoff_leaves = null;
    this.isMoreThanTwoDays = false;
  }

  openAddremark(action: string, employee: any, type: string) {
    this.isShowEmpDetails = true;
    this.addRemarks = true;
    this.compoff_leaves_flag = action;
    this.empDetails = employee;

    if (this.activeLeaveType.approvaltype == 'Leave') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Leave Request`;
      this.getLeaveDetailsForApproval(employee);
    } else if (this.activeLeaveType.approvaltype == 'On Duty') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} On Duty`
    } else if (this.activeLeaveType.approvaltype == 'Comp-Off Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Comp-Off Request`
      this.compoff_leaves = this.empDetails?.comp_off_days;
    } else if (this.activeLeaveType.approvaltype == 'WFH Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} WFH Request`
      if (action == 'A') {
        this.checkDateDifference(this.empDetails?.fromdate, this.empDetails?.todate);
      }
    } else if (this.activeLeaveType.approvaltype == 'Imprest Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Imprest Request`
    } else if (this.activeLeaveType.approvaltype == 'Travel Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Travel Request`
    } else if (this.activeLeaveType.approvaltype == 'Travel Expense') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Travel Expense`
    } else if (this.activeLeaveType.approvaltype == 'Missed Punch') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Missed Punch`
    } else if (this.activeLeaveType.approvaltype == 'Reimbursement Claim') {
      let actionTitle = 'Approve';
      if (action === 'R') actionTitle = 'Reject';
      else if (action === 'SB') actionTitle = 'Send Back';
      else if (action === 'PB') actionTitle = 'Pull Back';
      this.modalHeadText = `${actionTitle} Reimbursement Claim`;
      this.approvedAmount = this.empDetails?.approved_amount || this.empDetails?.expense_amount;
    }
    if (employee.docment_file) {
      this.isTicketFile = employee.docment_file.filter(doc => doc.doc_type == 'Ticket').length > 0;
      this.isHotelBill = employee.docment_file.filter(doc => doc.doc_type == 'Hotel Bill').length > 0;
    }

    setTimeout(() => {
      this.cdr.detectChanges(); // Ensures Angular updates the view safely
    });
    this.activeEmp = { ...employee, action: action, type: type };
  }

  openAddremarkExit(action: string, employee: any, type: string) {
    this.isShowEmployeeDetails = true;
    this.addRemarks = true;
    this.compoff_leaves_flag = action;
    this.empDetails = employee;

    if (this.activeLeaveType.approvaltype == 'Leave') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Leave Request`
    } else if (this.activeLeaveType.approvaltype == 'On Duty') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} On Duty`
    } else if (this.activeLeaveType.approvaltype == 'Comp-Off Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Comp-Off Request`
      this.compoff_leaves = this.empDetails?.comp_off_days;
    } else if (this.activeLeaveType.approvaltype == 'WFH Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} WFH Request`
    } else if (this.activeLeaveType.approvaltype == 'Imprest Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Imprest Request`
    } else if (this.activeLeaveType.approvaltype == 'Travel Request') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Travel Request`
    } else if (this.activeLeaveType.approvaltype == 'Travel Expense') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Travel Expense`
    } else if (this.activeLeaveType.approvaltype == 'Missed Punch') {
      this.modalHeadText = `${action == 'A' ? 'Approve' : 'Reject'} Missed Punch`
    } else if (this.activeLeaveType.approvaltype == 'Reimbursement Claim') {
      let actionTitle = 'Approve';
      if (action === 'R') actionTitle = 'Reject';
      else if (action === 'SB') actionTitle = 'Send Back';
      else if (action === 'PB') actionTitle = 'Pull Back';
      this.modalHeadText = `${actionTitle} Reimbursement Claim`;
      this.approvedAmount = this.empDetails?.approved_amount || this.empDetails?.expense_amount;
    }
    if (employee.docment_file) {
      this.isTicketFile = employee.docment_file.filter(doc => doc.doc_type == 'Ticket').length > 0;
      this.isHotelBill = employee.docment_file.filter(doc => doc.doc_type == 'Hotel Bill').length > 0;
    }

    setTimeout(() => {
      this.cdr.detectChanges(); // Ensures Angular updates the view safely
    });
    this.activeEmp = { ...employee, action: action, type: type };
  }

  requestAction() {
    // console.log(this.approvalType);
    // console.log(this.activeEmp);

    let applId = '';
    if (this.approvalType == 'On Duty') {
      applId = this.activeEmp?.od_applid;
    } else if (this.approvalType == 'WFH Request') {
      applId = this.activeEmp?.wfh_applid;
    } else if (this.approvalType == 'Comp-Off Request') {
      applId = this.activeEmp?.comp_applid;
    } else {
      applId = this.activeEmp?.leave_applid;
    }

    let postData = {
      customerAccountId: (this.tp_account_id || '').toString(),
      empId: this.activeEmp?.emp_id,
      empCode: this.activeEmp?.emp_code,
      productTypeId: this.product_type,
      approvalId: applId,
      travelId: this.activeEmp?.travel_id,
      travelStatus: this.activeEmp.action,
      approvalStatus: this.activeEmp.action,
      submittedBy: this.empDataFromParent?.emp_code || this.token?.emp_code || this.token?.id || '',
      p_attachment_url: this.azureImagePath || '',
      remark: this.remarks,
      travelRemarks: this.remarks,
      comp_off_days: this.compoff_leaves?.toString(),
      approvedAmount: this.approvedAmount,
      createdByIp: "::1"
    }


    if (this.activeEmp.type.includes('Leave')) {
      this._employeeMgmtService.approveRejectLeave(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('On Duty')) {
      this._employeeLoginService.approveRejectOnDuty(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Comp-Off Request')) {
      if (!this.compoff_leaves) return;
      this._employeeLoginService.approveRejectCompOffRequest(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.compoff_leaves = null;
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('WFH Request')) {

      if (this.isMoreThanTwoDays == true) {
        if (!this.azureImagePath) {
          this.toastr.error('Upload approval document for more than 2 consecutive WFH days. Please attach!')
          return;
        }
      }

      this._employeeLoginService.approveRejectWFHRequest(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.Save_AddEditPushNotifications(); // Send Push Notification
          this.hideEmpDetailModal();
          this.getMasterList();
          this.azureImagePath = '';

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Imprest Request')) {

      if (!this.expense_amount && this.activeEmp.action == 'A') {
        this.toastr.error("Expense Amount is required!");
        return;
      }

      if (this.activeEmp.action == 'A' && parseFloat(this.expense_amount) > parseFloat(this.activeEmp.amount_spent)) {
        this.toastr.error("Invalid amount entered!", 'Oops!');
        return;
      }

      if (!this.remarks) {
        this.toastr.error("Remarks are required!");
        return;
      }

      let obj = {
        customeraccountid: this.tp_account_id.toString(),
        action: "approved_ir_mobile_app",
        emp_id: this.activeEmp?.emp_id,
        approval_status: this.activeEmp.action, // (A, P or R)
        subuser_id: this.token?.subuser_id?.toString(),
        isemployer: this.token?.isEmployer?.toString(),
        user_name: this.activeEmp.emp_name,
        submittedby: this.empDataFromParent.emp_code,
        remark: this.remarks,
        // amount_spent: this.activeEmp?.amount_spent,
        amount_spent: this.expense_amount,
        appliedid: this.activeEmp?.ir_applid,
      }

      let date = new Date();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      let createdby = '';
      if (this.token.isEmployer == '0') {
        createdby = !this.token?.sub_userid ? this.tp_account_id : this.token.sub_userid;
      } else {
        createdby = this.tp_account_id;
      }

      let voucher_obj = {
        "voucherYear": year,
        "voucherMonth": month,
        "empCode": this.activeEmp?.mobile + 'CJHUB' + this.activeEmp?.emp_code + 'CJHUB' + this.activeEmp?.dateofbirth,
        "amount": this.expense_amount.toString(),
        "transactionType": "Credit",
        "ledgerType": "Reimbursement",
        "deductionId": this.activeEmp?.expense_category_id?.toString(),
        "subLedgerName": this.activeEmp?.expense_category_name,
        "isTaxableFlag": "N",
        "IsBillableFlag": "N",
        "createdBy": createdby?.toString(),
        "productTypeId": this.product_type.toString(),
        "customerAccountId": this.tp_account_id.toString(),
      }

      // console.log("ACTIVE USER", this.activeEmp);
      // console.log("OBJJ", obj);
      // return

      this._employeeLoginService.approveRejectImprestRequest(obj).subscribe((resData: any) => {
        if (resData.statusCode) {
          if (resData.checkflag == 'A' && this.activeEmp.action == 'A') {
            this.saveVoucher(voucher_obj);
          }
          this.remarks = '';
          this.expense_amount = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Request')) {
      this._employeeLoginService.approveTravelRequest(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Expense')) {
      this._employeeLoginService.approveRejectTravelExpense(postData).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Missed Punch')) {
      let obj = {
        action: "ApproveMissedPunch",
        // approvalId: this.activeEmp?.leave_applid,
        approvalId: this.activeEmp?.row_id,
        customerAccountId: this._encrypterService.aesEncrypt(this.tp_account_id.toString()),
        empCode: this._encrypterService.aesEncrypt(this.activeEmp?.emp_code),
        attDate: this.activeEmp?.att_date.replace(/\//g, '-'),
        attStatus: this.activeEmp?.action,
        "modifiedByUser": this.empDataFromParent?.emp_code,
        "modifiedByIp": "::2",
        "productTypeId": this._encrypterService.aesEncrypt(this.product_type),
        "isEmployer": this.token?.isEmployer,
        "subUserId": "0",
        remarks: this.remarks
      }


      this._employeeLoginService.approveRejectMissedPunch(obj).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.addRemarks = false;
          this.openAddApprovalModal(this.activeLeaveType);
          this.hideEmpDetailModal();
          this.getMasterList();

          this.toastr.success(resData.message);
        } else {
          this.toastr.error(resData.message);
        }
      })
    } else if (this.activeEmp.type.includes('Reimbursement') || this.approvalType == 'Reimbursement Claim') {
      if ((this.activeEmp.action == 'R' || this.activeEmp.action == 'SB' || this.activeEmp.action == 'PB') && !this.remarks) {
        this.toastr.error(`Remarks are required to ${this.activeEmp.action == 'SB' ? 'send back' : (this.activeEmp.action == 'PB' ? 'pull back' : 'reject')}!`);
        return;
      }
      const approvedAmt = this.approvedAmount || this.activeEmp?.approved_amount || this.activeEmp?.expense_amount;
      const isWorkflow = this.activeEmp?.is_workflow_applied === 'Y';
      const approverEmpCode = this.empDataFromParent?.emp_code || this.token?.emp_code || '';
      const approverName = this.empDataFromParent?.emp_name || this.token?.name || '';

      let actionType = 'updateClaimStatus';
      let claimStatus = this.activeEmp.action;

      if (this.activeEmp.action == 'A') {
        actionType = isWorkflow ? 'ApproveClaimLevel' : 'updateClaimStatus';
        claimStatus = 'A';
      } else if (this.activeEmp.action == 'SB') {
        actionType = 'RevertClaimLevel';
        claimStatus = 'P';
      } else if (this.activeEmp.action == 'PB') {
        actionType = 'PullBackClaimLevel';
        claimStatus = 'P';
      } else if (this.activeEmp.action == 'R') {
        actionType = 'updateClaimStatus';
        claimStatus = 'R';
      }

      let defaultRemark = 'Approved';
      if (this.activeEmp.action == 'R') defaultRemark = 'Rejected';
      else if (this.activeEmp.action == 'SB') defaultRemark = 'Sent back for review';
      else if (this.activeEmp.action == 'PB') defaultRemark = 'Pulled back';

      let claimPayload = {
        actionType: actionType,
        claimStatus: claimStatus,
        claimRejectReason: this.remarks || defaultRemark,
        approvedAmount: approvedAmt,
        empCode: this.activeEmp.emp_code,
        claimRecordId: this.activeEmp.claim_record_id,
        productTypeId: this.product_type,
        customerAccountId: this.tp_account_id?.toString(),
        createdBy: approverEmpCode,
        modifiedBy: approverEmpCode,
        subUserId: '',
        isEmployer: '0',
        actionByRole: 'Approver',
        approverName: approverName
      };

      this._employeeMgmtService.ManageReimbursementClaim(claimPayload).subscribe((resData: any) => {
        if (resData.statusCode) {
          this.remarks = '';
          this.approvedAmount = '';
          this.addRemarks = false;
          this.hideEmpDetailModal();
          this.getMasterList();
          this.toastr.success(resData.message || 'Action submitted successfully');
          if (this.showAddApprovalModal && this.activeLeaveType) {
            this.openAddApprovalModal(this.activeLeaveType);
          }
        } else {
          this.toastr.error(resData.message || 'Failed to update reimbursement claim');
        }
      }, (err: any) => {
        this.toastr.error(err?.message || 'Error updating reimbursement claim');
      });
    }
  }

  showEmpDetailsModal(empData: any) {
    this.isShowEmpDetails = true;
    this.empDetails = empData;
    // console.log(this.empDetails);
    if (empData.docment_file) {
      this.isTicketFile = empData.docment_file.filter(doc => doc.doc_type == 'Ticket').length > 0;
      this.isHotelBill = empData.docment_file.filter(doc => doc.doc_type == 'Hotel Bill').length > 0;
    }

    if (this.activeLeaveType.approvaltype == 'Leave') {
      this.modalHeadText = 'View Leave Request'
    } else if (this.activeLeaveType.approvaltype == 'On Duty') {
      this.modalHeadText = 'View On Duty'
    } else if (this.activeLeaveType.approvaltype == 'Comp-Off Request') {
      this.modalHeadText = 'View Comp-Off Request'
    } else if (this.activeLeaveType.approvaltype == 'WFH Request') {
      this.modalHeadText = 'View WFH Request'
    } else if (this.activeLeaveType.approvaltype == 'Travel Request') {
      this.modalHeadText = 'View Travel Request'
    } else if (this.activeLeaveType.approvaltype == 'Travel Expense') {
      this.modalHeadText = 'View Travel Expense'
    } else if (this.activeLeaveType.approvaltype == 'Missed Punch') {
      this.modalHeadText = 'View Missed Punch'
    } else if (this.activeLeaveType.approvaltype == 'Reimbursement Claim') {
      this.modalHeadText = 'View Reimbursement Claim';
    }

  }

  showExitEmployeeDetails(empData: any) {
    this.isShowEmployeeDetails = true;
    this.empDetails = empData;
    // console.log(this.empDetails);

  }

  //  Utility Functions --
  formatDate(dateStr: string): string {
    return dateStr?.replace(/\//g, '-') || '';
  }

  onInputLimit(event: any) {
    const max = this.empDetails?.max_leaves_per_compoff;
    const value = parseFloat(event.target.value);

    if (value > max) {
      event.target.value = max;
      this.compoff_leaves = max;
    }
    if (value < 0) {
      event.target.value = 0;
      this.compoff_leaves = 0;
    }
  }

  validateExpenseAmount() {
    if (this.expense_amount != null && this.empDetails?.amount_spent != null) {
      this.expenseAmountError = +this.expense_amount > +this.empDetails.amount_spent;
    } else {
      this.expenseAmountError = false;
    }
  }


  saveVoucher(obj: any) {
    this._approvalsService.SaveVoucher(obj).subscribe((resData: any) => {
      // console.log(resData,"Arpit");
      // return;
      if (resData.statusCode) {

      } else {

      }
    });

  }

  async exportToExcel(): Promise<void> {
    let dataToExport: any[] = [];
    let fileName: string = 'Approval_Data.xlsx';

    // The cleanRemarks function is still essential to create the newline characters that exceljs will use.
    const cleanRemarks = (remarks: string): string => {
      if (!remarks) return '';
      // This function now correctly handles complex HTML and prepares the text for Excel.
      return remarks
        // Step 1: Replace any sequence of <br> tags with a single newline.
        .replace(/(<br\s*\/?>\s*)+/gi, '\n')
        // Step 2: Strip all other HTML tags.
        .replace(/<\/?[^>]+(>|$)/g, "")
        // Step 3: Collapse multiple spaces.
        .replace(/ +/g, ' ')
        .trim();
    };

    // --- (The entire data preparation logic you provided is kept as is) ---
    if (this.fullAndFinal) {
      if (this.employeesInFullFinal.length === 0) {
        this.toastr.warning('No data to export.');
        return;
      }
      fileName = `Exit_Process_List_${this.leaveStatus}.xlsx`;
      dataToExport = this.employeesInFullFinal.map(emp => ({
        'Employee Name': emp.emp_name,
        'Employee Code': emp.orgempcode || emp.tpcode,
        'Department': emp.posting_department,
        'Designation': emp.post_offered,
        'Status': emp.clearance_approved_status || 'Pending'
      }));
    } else {
      if (this.approvalDataByActionType.length === 0) {
        this.toastr.warning('No data to export.');
        return;
      }
      // console.log(this.approvalDataByActionType);
      fileName = `${this.approvalType.replace(/ /g, '_')}_${this.leaveStatus}.xlsx`;
      dataToExport = this.approvalDataByActionType.map(item => {
        let statusText = '';
        const getItemStatus = (item: any, approvalType: string): string => {
          switch (approvalType) {
            case 'Leave':
              // If approval_status is 'P', it's pending. Otherwise, map 'A'/'R'.
              if (item.approval_status === 'Pending') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                // return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.approval_status;

            case 'Imprest Request':
              // If approval_status is 'P', it's pending. Otherwise, map 'A'/'R'.
              if (item.approval_status === 'Pending') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                // return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.approval_status;

            case 'On Duty':
            case 'WFH Request':
            case 'Comp-Off Request':
              if (item.approval_status === 'Pending') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                //return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.approval_status;

            case 'Missed Punch':
              if (item.mis_punch_approval_status === 'P') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                //return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.mis_punch_approval_status === '' ? 'Pending' : (item.mis_punch_approval_status === 'A' ? 'Approved' : (item.mis_punch_approval_status === 'R' ? 'Rejected' : ''));

            case 'Travel Request':
              if (item.travel_request_status === 'P') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                //return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.travel_request_status === 'A' ? 'Approved' : (item.travel_request_status === 'R' ? 'Rejected' : '');

            case 'Travel Expense':
              if (item.travel_expense_status === 'S') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                //return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.travel_expense_status === 'A' ? 'Approved' : (item.travel_expense_status === 'R' ? 'Rejected' : ' ');

            default:
              if (item.approval_status === 'Pending' || item.approval_status === 'P' || item.clearance_approved_status === 'P') {
                if (this.isShowActionButton(item)) {
                  return 'Pending';
                } else if (item.approval_name_pending) {
                  return `Pending at ${item.approval_name_pending}`;
                }
                //return `Pending at Level ${item.wf_approval_cur_level || item.wf_approval_cur_level_exp || item.wf_approval_cur_level_req || 'N/A'}`;
              }
              return item.approval_status === 'A' ? 'Approved' : (item.approval_status === 'R' ? 'Rejected' : item.approval_status);
          }
        };


        // Now use the helper function within your map
        switch (this.approvalType) {
          case 'Leave':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Leave Type': item.leavetypecode,
              'Subject': item.leave_subject,
              'Description': item.leave_description,
              'From Date': item.fromdate,
              'To Date': item.todate,
              'Applied On': item.createdon,
              'Status': getItemStatus(item, 'Leave'),
              'Remarks': cleanRemarks(item.action_comment_txt)
            };
          case 'Imprest Request':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Status': getItemStatus(item, 'Imprest Request'), // Use the helper
              'Applied On': item.createdon,
              'Request Amount': item.amount_spent,
              'Approved Amount': item.approved_amount_spent || 'N/A',
              'Expense Category': item.expense_category_name,
              'Remarks': cleanRemarks(item.action_comment_txt)
            };
          case 'On Duty':
          case 'WFH Request':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Status': getItemStatus(item, this.approvalType),
              'Applied On': item.createdon,
              'From Date': item.fromdate,
              'To Date': item.todate,
              'Description': item.od_description || item.wfh_description,
              'Remarks': cleanRemarks(item.action_comment_txt)
            };
          case 'Comp-Off Request':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Status': getItemStatus(item, this.approvalType),
              'Comp Off Date': item.comp_off_applied_date,
              'Start Time': item.working_start_time,
              'End Time': item.working_end_time,
              'Working Hours': item.working_hours,
              'Remarks': cleanRemarks(item.action_comment_txt)
            };
          case 'Missed Punch':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Status': getItemStatus(item, 'Missed Punch'), // Use the helper
              'Attendance Date': item.att_date,
              'Category': item.att_catagory_txt,
              'Check In Time': item.check_in_time,
              'Check Out Time': item.check_out_time,
              'Remarks': cleanRemarks(item.action_comment_txt)
            };
          case 'Travel Request':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Purpose': item.purpose,
              'From Place': item.place_of_travel_from,
              'To Place': item.place_of_travel_to,
              'From Date': item.date_of_travel_from,
              'To Date': item.date_of_travel_to,
              'Mode of Travel': item.mode_of_travel,
              // 'Advance Required': item.travel_adv_flag,
              'Advance Amount': item.travel_adv_amount,
              'Status': getItemStatus(item, 'Travel Request'),
              'Applied On': item.createdon,
              'Remarks': cleanRemarks(item.action_comment_txt_req)
            };
          case 'Travel Expense':
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Purpose': item.purpose,
              'From Place': item.place_of_travel_from,
              'To Place': item.place_of_travel_to,
              'From Date': item.date_of_travel_from,
              'To Date': item.date_of_travel_to,
              'Mode of Travel': item.mode_of_travel,
              'Advance Amount': item.travel_adv_amount,
              'Transportation': item.transportation,
              'Accommodation': item.accommodation,
              'Status': getItemStatus(item, 'Travel Expense'),
              'Applied On': item.createdon,
              'Remarks': cleanRemarks(item.action_comment_txt_exp)
            };
          default:
            return {
              'Employee Name': item.emp_name,
              'Employee Code': item.orgempcode || item.cjcode || item.tpcode || item.tp_code,
              'Status': getItemStatus(item, this.approvalType),
              'Applied On': item.createdon
            };
        }
      });
    }
    if (dataToExport.length === 0) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const headers = Object.keys(dataToExport[0]);
    worksheet.columns = headers.map(header => {
      let columnWidth = 20;
      if (header === 'Employee Name') columnWidth = 25;
      if (header === 'Remarks') columnWidth = 60;
      if (header === 'Description') columnWidth = 50;
      if (header === 'Status') columnWidth = 30;
      return { header, key: header, width: columnWidth };
    });

    worksheet.addRows(dataToExport);

    // Style the header row (center-aligned)
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

    const columnsToWrap = ['Remarks', 'Description', 'Status']; // Added 'Status'

    // Iterate over all data rows (skipping the header row) to apply alignment
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          const headerKey = worksheet.getColumn(colNumber).key;
          if (columnsToWrap.includes(headerKey)) {
            cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
          } else {
            cell.alignment = { vertical: 'top', horizontal: 'left' };
          }
        });
      }
    });

    // Generate and Download the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }


  applyFilter(): void {
    const searchTerm = this.searchText?.trim()?.toLowerCase();

    // Condition Check 1: If search term is empty, restore the original list
    if (!searchTerm) {
      if (this.fullAndFinal) {
        this.employeesInFullFinal = [...this._allEmployeesInFullFinal];
      } else {
        this.approvalDataByActionType = [...this._allApprovalDataByActionType];
      }
      return;
    }

    // Condition Check 2: Filter the appropriate list based on the active view
    if (this.fullAndFinal) {
      this.employeesInFullFinal = this._allEmployeesInFullFinal.filter(emp =>
        emp.emp_name?.toLowerCase().includes(searchTerm) ||
        (emp.orgempcode && emp.orgempcode?.toLowerCase().includes(searchTerm)) ||
        (emp.tpcode && emp.tpcode?.toLowerCase().includes(searchTerm))
      );
    } else {
      this.approvalDataByActionType = this._allApprovalDataByActionType.filter(item =>
        item.emp_name?.toLowerCase().includes(searchTerm) ||
        (item.orgempcode && item.orgempcode?.toLowerCase().includes(searchTerm)) ||
        (item.cjcode && item.cjcode?.toLowerCase().includes(searchTerm)) || // Handle cjcode as seen in your HTML
        (item.tpcode && item.tpcode?.toLowerCase().includes(searchTerm)) ||     // Handle tpcode as seen in travel data
        (item.tp_code && item.tp_code?.toLowerCase().includes(searchTerm))
      );
    }
  }

  onFormSubmit(event: Event): void {
    event.preventDefault();
  }

  onSearchEnter(event: KeyboardEvent): void {
    event.preventDefault();
    this.applyFilter();
  }

  onlogoFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.logofileName = file.name;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64WithPrefix = reader.result as string;
        this.logoPreviewUrl = base64WithPrefix;
        this.uploadSignatureImageToAzure(base64WithPrefix, this.logofileName);
      };

      reader.onerror = () => {
        this.toastr.error('Failed to read file', 'Error');
      };
    } else {
      this.logofileName = 'Choose file';
    }
  }

  uploadSignatureImageToAzure(base64Data: string, fileName: string) {

    const payload = {
      data: base64Data,
      name: fileName
    };

    this._employeeMgmtService.uploadSignatureImage(payload).subscribe((res: any) => {
      if (res.status) {
        this.azureImagePath = res.file_path;
        this.toastr.success('Attachements uploaded successfully');
        //console.log('Azure Path:', this.azureImagePath);
        // this.emailTemplateForm.get('imageUrl')?.setValue(azureImagePath);
      } else {
        this.toastr.error(res.message, 'Error');
      }
    });

  }

  checkDateDifference(fromdate: string, todate: string) {
    if (this.accountsWFHAllowed?.includes(this.tp_account_id?.toString())) {

      if (fromdate && todate) {
        const [fromDay, fromMonth, fromYear] = fromdate.split('-').map(Number);
        const [toDay, toMonth, toYear] = todate.split('-').map(Number);

        const fromDateObj = new Date(fromYear, fromMonth - 1, fromDay);
        const toDateObj = new Date(toYear, toMonth - 1, toDay);

        const diffTime = toDateObj.getTime() - fromDateObj.getTime();
        const diffDays = (diffTime / (1000 * 3600 * 24)) + 1;// Including both start and end date
        if (diffDays > 2) {
          this.isMoreThanTwoDays = true;
        } else {
          this.isMoreThanTwoDays = false;
        }

      }
    }

  }

  viewConfirmModal(url: string) {
    this.pdfModal = true;
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.pdfUrlViewIdCard = safeUrl;
  }

  closeConfirmModal() {
    this.pdfModal = false;
    this.pdfUrlViewIdCard = '';
  }

  Save_AddEditPushNotifications() {

    let action = 'AddAutoApprovedNotifications';
    let notificationTitle = 'WFH Request Approved';
    let campaignId: any = '';
    let campaignName = 'WFH Request Approved';
    let notificationDescription = `WFH Request Approved by ${this.token?.name} at ${new Date().toLocaleString()}.`;

    let dateStr = moment(new Date()).format('DD/MM/YYYY');

    let obj = {
      "customerAccountId": this.tp_account_id?.toString(),
      "action": action,
      "createdBy": this.tp_account_id?.toString(),
      "startDate": dateStr,
      "endDate": dateStr,
      "notificationAudienceIds": this.activeEmp?.emp_id?.toString(),
      "notificationTitle": notificationTitle,
      "campaignId": campaignId,
      "campaignName": campaignName,
      "notificationDescription": notificationDescription
    }
    // return;

    this.broadcasterService.AddEditPushNotifications(obj).subscribe((resData: any) => {
      if (resData.statusCode) {
        this.toastr.success(resData.message);
      } else {
        this.toastr.error(resData.message);
      }
    });

  }

  getLeaveDetailsForApproval(employee: any) {
    console.log("Employee Data", employee);

    let obj = {
      "account_id": this.tp_account_id?.toString(),
      "action": 'get_leave_details_for_approval',
      "leave_applid": employee?.leave_applid?.toString(),
      "emp_id": employee?.emp_id?.toString(),
      "leavetypecode": employee?.leavetypecode?.toString()
    };

    this._employeeMgmtService.getLeaveDetailsForApproval(obj).subscribe((resData: any) => {
      if (resData.statusCode) {
        this.leaveDetailsForApproval = JSON.parse(this._encrypterService.aesDecrypt(resData.commonData));
        // console.log("Leave Details For Approval", this.leaveDetailsForApproval);
      } else {
        this.toastr.error(resData.message);
      }
    });

  }



  isDocumentViewImage: boolean = false;
  documentUrlToView: any = null;
  rawDocumentUrl: string = '';
  isDocViewerMaximized: boolean = false;

  isImageFile(url: string | null | undefined): boolean {
    if (!url) return false;
    const cleanUrl = url.split('?')[0].toLowerCase();
    return cleanUrl.endsWith('.jpg') || 
           cleanUrl.endsWith('.jpeg') || 
           cleanUrl.endsWith('.png') || 
           cleanUrl.endsWith('.webp') || 
           cleanUrl.endsWith('.gif') || 
           cleanUrl.endsWith('.bmp') ||
           cleanUrl.includes('.jpg') ||
           cleanUrl.includes('.jpeg') ||
           cleanUrl.includes('.png');
  }

  viewDocument(url: string) {
    if (!url) {
      this.toastr.warning('Document URL is not available.');
      return;
    }
    this.rawDocumentUrl = url;
    this.isDocumentViewImage = this.isImageFile(url);
    if (this.isDocumentViewImage) {
      this.documentUrlToView = url;
    } else {
      this.documentUrlToView = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    const modal = document.getElementById('documentViewerModal');
    if (modal) {
      modal.classList.add("show");
      modal.style.display = "block";
    }
  }

  toggleDocViewerMaximize() {
    this.isDocViewerMaximized = !this.isDocViewerMaximized;
  }

  downloadDocument(url: string) {
    if (!url) {
      this.toastr.warning('Document URL is not available.');
      return;
    }
    const fileName = url.split('/').pop()?.split('?')[0] || 'document';
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.blob();
      })
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(() => {
        window.open(url, '_blank');
      });
  }

  closeDocumentViewer() {
    const modal = document.getElementById('documentViewerModal');
    if (modal) {
      modal.classList.remove("show");
      modal.style.display = "none";
    }
    this.documentUrlToView = null;
    this.rawDocumentUrl = '';
    this.isDocViewerMaximized = false;
  }

}
